// extracted by mini-css-extract-plugin
export default {"container":"Dq-z","heading":"Eq-z","text":"Fq-z","info":"Gq-z","link":"Hq-z","fullMaxWidth":"Iq-z"};